module.exports = __webpack_public_path__ + "media/toms-guide-d648b919.svg";